/**
 * Encodes string to a base64 string.
 */
export function base64Encode(str: string): string {
  if (typeof TextEncoder !== 'undefined') {
    const uint8Array = new TextEncoder().encode(str);
    return btoa(String.fromCharCode(...uint8Array));
  } else {
    // https://observablehq.com/@a10k/why-use-unescape-encodeuricomponent-combo-for-btoa
    return btoa(unescape(encodeURIComponent(str)));
  }
}

/**
 * Decodes a base64 string to an object.
 * Source: https://developer.mozilla.org/en-US/docs/Glossary/Base64
 */
export function base64Decode(base64String: string): string {
  if (typeof TextEncoder !== 'undefined') {
    const binaryString = atob(base64String);
    const uint8Array = Uint8Array.from(binaryString, (char) =>
      char.charCodeAt(0),
    );
    return new TextDecoder().decode(uint8Array);
  } else {
    // https://observablehq.com/@a10k/why-use-unescape-encodeuricomponent-combo-for-btoa
    return decodeURIComponent(escape(atob(base64String)));
  }
}
